import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Folder } from 'src/app/models/folder';
import { FolderApiService } from 'src/app/services/folder-api.service';
import { ToastService } from 'src/app/services/toasts.service';

@Component({
    selector: 'app-folder-selection-modal',
    templateUrl: './folder-selection-modal.component.html',
    styleUrl: './folder-selection-modal.component.scss',
})
export class FolderSelectionModalComponent implements OnInit {
  @Input("folders") rootFolders: Folder[] = [];
  @Input("initialPath") initialPath: Folder[] = [];
  currentPath: Folder[] = [];
  displayedFolders: Folder[] = [];

  constructor(
    public modal: NgbActiveModal,
    private toastService: ToastService
  ) {}

  ngOnInit(): void {
    this.currentPath = this.initialPath;
    this.displayedFolders = this.initialPath.length > 0 ? this.initialPath[this.initialPath.length-1].subFolders || [] : [...this.rootFolders];
  }

  resetToRootView(): void {
    this.currentPath = [];
    this.displayedFolders = [...this.rootFolders];
  }

  navigateToFolder(folder: Folder): void {
    this.currentPath.push(folder);
    this.displayedFolders = folder.subFolders || [];
  }

  navigateToBreadcrumb(index: number): void {
    if (index < 0) {
      // Clicking "Root"
      this.resetToRootView();
    } else {
      const targetFolder = this.currentPath[index];
      this.currentPath = this.currentPath.slice(0, index + 1);
      this.displayedFolders = targetFolder.subFolders || [];
    }
  }

  get currentSelectedFolderAsDestination(): Folder | null {
    return this.currentPath.length > 0
      ? this.currentPath[this.currentPath.length - 1]
      : null;
  }

  confirmSelection(): void {
    if (this.currentSelectedFolderAsDestination) {
      this.modal.close(this.currentSelectedFolderAsDestination.guid);
    }
  }

  dismiss(): void {
    this.modal.dismiss();
  }
}
